import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { seReportDeleteKeyImages, seReportSetKeyImages } from '../../../report/report.actions';
import { seViewerKeyImagesPerRows } from '../../../root-store/root.actions';
import { KeyImage } from '../../../services/imaging/common';
import { ISeSideExaminationStudy, ISeSideKeyObject, SeSideImagesType } from './se-side-key-images-models';
import { ServerRootService } from '../../../utils/routing/serverroot.service';

@Injectable({
    providedIn: 'root',
})
export class KeyImagesService extends ServerRootService {
    private readonly baseUrl = this.getServerRoot() + '/ClinicalRepository';

    constructor(
        private http: HttpClient,
        private store: Store,
    ) {
        super();
    }

    getKeyImages(
        keyData: ISeSideKeyObject[],
        examinationStudies: ISeSideExaminationStudy[],
    ): Observable<SeSideImagesType[]> {
        const keyImages: ISeSideKeyObject[] = keyData.filter(
            (k) => !!k.IdExamination && !!k.RepositoryKey && !!k.SOPInstanceUID,
        );
        return this.http.post<SeSideImagesType[]>(
            `${this.baseUrl}/GetKeyImages`,
            { keyImages, examinationStudies },
            this.buildOptions(),
        );
    }

    deleteKeyImages(repositoryKeys: string[]): Observable<unknown> {
        const keyImages = repositoryKeys.map((repositoryKey) => ({ repositoryKey }));

        return this.http.post<SeSideImagesType[]>(
            `${this.baseUrl}/DeleteKeyImages`,
            { keyImages },
            this.buildOptions(null, true),
        );
    }

    saveKeyImagesData(images: KeyImage[]) {
        this.store.dispatch(seReportSetKeyImages({ keyImages: images }));
    }

    requestKeyImageDeletion(image: KeyImage) {
        this.store.dispatch(seReportDeleteKeyImages({ keyImages: [image] }));
    }

    requestAllKeyImagesDeletion(data: KeyImage[]) {
        const imagesToBeDeleted = data.filter((k) => k.IsDeletable);

        this.store.dispatch(seReportDeleteKeyImages({ keyImages: imagesToBeDeleted }));
    }

    saveRowValue(data: number) {
        this.store.dispatch(seViewerKeyImagesPerRows({ rows: data }));
    }
}
